// field's name which is used for tiles and metrics that have goal parameter
export const GOAL_FIELD = 'goal';
